@if (carouselElements && currentCarouselCard) {
  <div class="carousel-card-component">
    <div class="above-header-container">
      <img src="/public/assets/images/hand-arm-heart.svg" alt="hand hearth icon" />
      <h2>{{ carouselElements.carouselText.title }}</h2>
    </div>
    <div class="bottom-header-container">
      <p>{{ carouselElements.carouselText.subtitle }}</p>
    </div>
    <div class="controller-container">
      <div [ngClass]="currentIndex + 1 === 1 ? 'reached' : null" class="button-controller">
        <img src="/public/assets/images/LeftCircleWhite.svg" alt="left control carousel" (click)="previous()" />
        <p class="bold">{{ currentIndex + 1 }}</p>
      </div>
      <p>{{ carouselElements.carouselText.middleNumberText }}</p>
      <div [ngClass]="currentIndex + 1 === carouselElements.cardsContent.length ? 'reached' : null" class="button-controller">
        <p>{{ carouselElements.cardsContent.length }}</p>
        <img src="/public/assets/images/RightCircleWhite.svg" alt="right control carousel" (click)="next()" />
      </div>
    </div>
    <div class="card-container">
      <app-card-with-image [cardImageContent]="currentCarouselCard">
        <ds-button
          [text]="currentCarouselCard.buttonText"
          [iconRight]="currentCarouselCard.iconButton ? '/public/assets/images/' + currentCarouselCard.iconButton : null"
          [styleType]="'undressed-accent'"
          [width]="'small'"
          (click)="actionButton(currentCarouselCard.id)"
        ></ds-button>
      </app-card-with-image>
    </div>
  </div>
}
